var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPrivacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8105 1.23295C11.5669 0.921023 12.4281 0.924169 13.1858 1.23148L13.1873 1.23206L20.1873 4.08364C21.2451 4.51473 22 5.51662 22 6.68768V10.9971C22 16.5682 17.8213 21.7214 12.2185 22.9758L12 23.0248L11.7815 22.9758C6.17869 21.7214 2 16.5682 2 10.9971V6.68768C2 5.51662 2.75475 4.51478 3.81262 4.08368L10.8105 1.23295ZM12.4335 3.0846C12.1523 2.97075 11.8349 2.97362 11.5721 3.08228L11.5673 3.08428L4.56738 5.9358C4.56734 5.93582 4.56742 5.93578 4.56738 5.9358C4.18533 6.09154 4 6.41005 4 6.68768V10.9971C4 15.5323 7.3936 19.8326 12 20.9727C16.6064 19.8326 20 15.5323 20 10.9971V6.68768C20 6.41005 19.8148 6.09159 19.4327 5.93585C19.4327 5.93583 19.4328 5.93586 19.4327 5.93585L12.4335 3.0846C12.4333 3.08451 12.4338 3.08469 12.4335 3.0846Z",
    fill: "#1C1F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7241 9.31035C17.105 9.71028 17.0896 10.3433 16.6897 10.7241L12.4897 14.7241C12.1034 15.092 11.4966 15.092 11.1103 14.7241L8.31035 12.0575C7.91042 11.6766 7.89498 11.0436 8.27586 10.6437C8.65675 10.2437 9.28973 10.2283 9.68966 10.6092L11.8 12.619L15.3103 9.27586C15.7103 8.89498 16.3433 8.91042 16.7241 9.31035Z",
    fill: "#1C1F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrivacy);
export default __webpack_public_path__ + "static/media/Ic_Privacy.f728c9bae1bf9150de198ea7ac938b24.svg";
export { ForwardRef as ReactComponent };